import { useLayoutEffect, useState } from 'react';

export default function useRem() {
    const [rem, setRem] = useState(0);
    useLayoutEffect(() => {
        function updateSize() {
            const r = parseFloat(
                getComputedStyle(document.documentElement).fontSize
            );

            setRem(r)
        }

        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return rem;
}
